import React from "react";
import { Container } from "reactstrap";
import BedIcon from "../../assets/img/bed.svg?react";
import CreditCardIcon from "../../assets/img/credit-card.svg?react";
import DocumentIcon from "../../assets/img/document.svg?react";
import InvoiceIcon from "../../assets/img/invoice.svg?react";
import { SUPPORT_EMAILS, SUPPORT_PHONES, SUPPORT_HOURS } from "./constants";
import "./contactUs.scss";

const ContactUs = () => {
  return (
    <Container
      fluid
      className="contact-us-container"
      id="contact-us"
      data-heap-id="contact-us"
    >
      <div className="contact-us-header">
        <h1 className="contact-us-title">Customer Support</h1>
      </div>

      <div className="contact-us-content">
        <div className="contact-us-card">
          <div className="contact-us-page__sections">
            {/* Left Column */}
            <div className="contact-us-page__column contact-us-page__column--left">
              {/* Reservations inquiries */}
              <div className="contact-us-section">
                <div className="contact-us-section__header">
                  <div className="contact-us-section__icon-wrapper">
                    <BedIcon className="contact-us-section__icon" />
                  </div>
                  <h2 className="contact-us-section__title">
                    Reservations inquiries
                  </h2>
                </div>
                <div className="contact-us-section__content">
                  <div className="contact-us-section__item">
                    <a
                      href={`mailto:${SUPPORT_EMAILS.CUSTOMER_SERVICE}`}
                      className="contact-us-section__link contact-us-section__link--email"
                    >
                      {SUPPORT_EMAILS.CUSTOMER_SERVICE}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <a
                      href={`tel:${SUPPORT_PHONES.CUSTOMER_SERVICE.replace(/\s/g, "")}`}
                      className="contact-us-section__link"
                    >
                      {SUPPORT_PHONES.CUSTOMER_SERVICE}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <p className="contact-us-section__text">
                      {SUPPORT_HOURS.TWENTY_FOUR_SEVEN}
                    </p>
                  </div>
                </div>
              </div>

              {/* VCC inquiries */}
              <div className="contact-us-section">
                <div className="contact-us-section__header">
                  <div className="contact-us-section__icon-wrapper">
                    <CreditCardIcon className="contact-us-section__icon" />
                  </div>
                  <h2 className="contact-us-section__title">VCC inquiries</h2>
                </div>
                <div className="contact-us-section__content">
                  <div className="contact-us-section__item">
                    <a
                      href={`mailto:${SUPPORT_EMAILS.CUSTOMER_SERVICE}`}
                      className="contact-us-section__link contact-us-section__link--email"
                    >
                      {SUPPORT_EMAILS.CUSTOMER_SERVICE}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <a
                      href={`tel:${SUPPORT_PHONES.CUSTOMER_SERVICE.replace(/\s/g, "")}`}
                      className="contact-us-section__link"
                    >
                      {SUPPORT_PHONES.CUSTOMER_SERVICE}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <p className="contact-us-section__text">
                      {SUPPORT_HOURS.TWENTY_FOUR_SEVEN}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="contact-us-page__column contact-us-page__column--right">
              {/* Content, taxes, policies, ARI and fee updates */}
              <div className="contact-us-section">
                <div className="contact-us-section__header">
                  <div className="contact-us-section__icon-wrapper">
                    <DocumentIcon className="contact-us-section__icon" />
                  </div>
                  <h2 className="contact-us-section__title">
                    Content, taxes, policies, ARI and fee updates
                  </h2>
                </div>
                <div className="contact-us-section__content">
                  <div className="contact-us-section__item">
                    <a
                      href={`mailto:${SUPPORT_EMAILS.OPERATIONS}`}
                      className="contact-us-section__link contact-us-section__link--email"
                    >
                      {SUPPORT_EMAILS.OPERATIONS}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <p className="contact-us-section__text">
                      {SUPPORT_HOURS.OPERATIONS}
                    </p>
                  </div>
                </div>
              </div>

              {/* Direct billing or invoice inquiries */}
              <div className="contact-us-section">
                <div className="contact-us-section__header">
                  <div className="contact-us-section__icon-wrapper">
                    <InvoiceIcon className="contact-us-section__icon" />
                  </div>
                  <h2 className="contact-us-section__title">
                    Direct billing or invoice inquiries
                  </h2>
                </div>
                <div className="contact-us-section__content">
                  <div className="contact-us-section__item">
                    <a
                      href={`mailto:${SUPPORT_EMAILS.AP_INVOICE}`}
                      className="contact-us-section__link contact-us-section__link--email"
                    >
                      {SUPPORT_EMAILS.AP_INVOICE}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <a
                      href={`tel:${SUPPORT_PHONES.BILLING.replace(/\s/g, "")}`}
                      className="contact-us-section__link"
                    >
                      {SUPPORT_PHONES.BILLING}
                    </a>
                  </div>
                  <div className="contact-us-section__item">
                    <p className="contact-us-section__text">
                      {SUPPORT_HOURS.BILLING}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ContactUs;
